import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import { Button } from '@mui/material';

interface ShareDialogProps {
  open: boolean;
  loading: boolean;
  onClose: () => void;
  onConfirm: () => void;
  labels: {
    title: string;
    confirm: string;
    cancel: string;
    content: string;
    loading: string;
  };
}

export const ShareDialog: React.FC<ShareDialogProps> = ({
  open,
  loading,
  onClose,
  onConfirm,
  labels,
}) => (
  <Dialog open={open} onClose={onClose}>
    <DialogTitle>{labels.title}</DialogTitle>
    <DialogContent>
      <DialogContentText>{labels.content}</DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} disabled={loading}>
        {labels.cancel}
      </Button>
      <Button onClick={onConfirm} color="primary" disabled={loading}>
        {loading ? labels.loading : labels.confirm}
      </Button>
    </DialogActions>
  </Dialog>
);
